import $ from 'jquery';
const domElements = {};

function initDomElements() {
  domElements.main = $('.page-header__service-nav');
  if (domElements.main.length < 1) return false;
  domElements.items = domElements.main.find('>ul >li');
  domElements.overlays = $('.page-header__service-nav__overlay');
  domElements.overlaySearch = $('.page-header__service-nav__overlay--search');
  domElements.overlayLanguage = $('.page-header__service-nav__overlay--language');
  domElements.overlayMiniCart = $('.page-header__service-nav__overlay--mini-cart');

  return true;
}

function serviceNav() {
  if (!initDomElements()) {
    return false;
  }

  domElements.items.on('click', '>a', event => {
    const $a = $(event.currentTarget);
    const $li = $a.parent();

    domElements.overlays.removeClass('open');

    if ($li.is('.search, .language, .cart')) {
        event.preventDefault();
    }

    if ($li.hasClass('open')) {
      domElements.items.removeClass('open');
    } else {
      $li.addClass('open');

      if ($li.hasClass('search')) {
        domElements.overlaySearch.addClass('open');
        domElements.overlaySearch.find('input').focus();
      }
      if ($li.hasClass('language')) {
        domElements.overlayLanguage.addClass('open');
      }
      if ($li.hasClass('cart')) {
        domElements.overlayMiniCart.addClass('open');
      }
    }
  });

  // if (!isTouchDevice()) {
  //   return false;
  // }
  //
  // domElements.level1Items.on('touchend', '>a', event => {
  //   const $a = $(event.currentTarget);
  //   const $li = $a.parent();
  //
  //   if ($li.find('ul').length < 1) {
  //     return true;
  //   }
  //
  //   if ($li.hasClass('touch-event')) {
  //     return true;
  //   }
  //
  //   event.preventDefault();
  //
  //   domElements.level1Items.removeClass('touch-event');
  //   $li.addClass('touch-event');
  // });
}

// function isTouchDevice() {
//   return (('ontouchstart' in window) ||
//       (navigator.maxTouchPoints > 0) ||
//       (navigator.msMaxTouchPoints > 0));
// }

export default serviceNav;
